import BillDateWithTimezone from "@/common/components/BillDateWithTimezone";
import Button from "@/common/components/Button";
import ImageWithDisplayName from "@/common/components/ImageWithDisplayName";
import { billingBillStatus } from "@/common/constants/statusBills.constants";
import { formatCurrency } from "@/common/utils/formatters";
import { CompanyBillData } from "@/features/privateCompanies/types/companyBills.type";
import { AlertCircleIcon, ArrowBigRightIcon, BriefcaseBusinessIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import { companySubGroupableKlass } from "../constants/companySubGroupableKlass.constant";
import { formatDatePeriodFriendlyName } from "@/common/utils/dateTransformer";

export class CompanyBillsTransformer {
  static tableTransformer() {
    return (companyBills: CompanyBillData[]) => {
      return companyBills.map((bill) => ({
        ...bill,
        _className: bill.status === 'rejected_by_company' && 'bg-red-op-2',
        status: (
          <div className="flex items-center gap-2">
            <p>
              {bill.status ? billingBillStatus.find(({ value }) => value === bill?.status)?.label : ''}
            </p>

            {bill.rejected_by_company_at && (
              <>
                <AlertCircleIcon
                  strokeWidth={1.5}
                  className="text-red-500 size-4"
                  data-tooltip-id="bill-rejected-tooltip"
                />

                <Tooltip id="bill-rejected-tooltip" className="text-sm z-50">
                  Fatura rejeitada
                </Tooltip>
              </>
            )}
          </div>
        ),
        groupable_display_name: (
          <p>
            {bill.grouping_mode !== 'by_government_allocation' ? bill.groupable?.display_name || 'Nenhum' : 'Empenho'}
            {bill?.sub_groupable_klass && (
              <span className="italic">
                &nbsp; - &nbsp;
                {companySubGroupableKlass[bill?.sub_groupable_klass]}
              </span>
            )}
          </p>
        ),
        company_branch_info: (
          <ImageWithDisplayName
            placeholderIcon={BriefcaseBusinessIcon}
            imageUrl={bill.client_branch?.general_information?.company_logo?.url}
            displayName={bill.client_branch?.display_name || '--'}
          />
        ),
        credit_info: bill?.granted_credit ? formatCurrency(parseFloat(`${bill?.granted_credit}`)) : undefined,
        total_amount: bill?.total_amount ? formatCurrency(parseFloat(`${bill?.total_amount}`)) : "Não informado",
        opened_at: bill?.opened_at && (
          <BillDateWithTimezone
            date={bill.opened_at}
            timezone={bill.time_zone}
          />
        ),
        closed_at: bill?.closed_at && (
          <BillDateWithTimezone
            date={bill.closed_at}
            timezone={bill.time_zone}
          />
        ),
        period: formatDatePeriodFriendlyName({
          closedAt: bill?.closed_at,
          openedAt: bill?.opened_at,
          contractualCycle: bill?.contractual_cycle,
        }),
        actions: (
          <div className="flex justify-center items-center">
            <Link to={bill.id} data-testid="show_bill_button">
              <Button variant="link-white" operationKlassToCheckPermission="Admin::Billing::Bills::Show" className="w-full">
                <ArrowBigRightIcon strokeWidth={1} />
              </Button>
            </Link>
          </div>
        ),
      }));
    };
  }
}
